<script setup lang="ts">
import { ElConfigProvider } from 'element-plus';
import { RouterView } from 'vue-router';
import { elLocaleMap } from './store/locale';
import { LocaleType } from './store/locale';
import '@/style/base.scss';
import '@/style/format.scss';
import { log } from './utils/log';
import customFont from './utils/customFont';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollToPlugin) 
gsap.registerPlugin(MorphSVGPlugin) 
gsap.registerPlugin(MotionPathPlugin) 
const { getCurrentLocale } = useStore('locale');
const language = computed(() => elLocaleMap[getCurrentLocale.value as LocaleType]);
onMounted(() => {
    setTimeout(() => {
        log('PV');
    }, 200);
});
customFont();
</script>
<template>
    <el-config-provider :locale="language">
        <RouterView />
    </el-config-provider>
</template>

<style lang="scss">
</style>
